import React from "react";
import { useModalState } from "../../helpers/ModalProvider";
import { Flex, Text } from "@chakra-ui/react";
import { Button } from "../../components/ui/button";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogDescription,
} from "../../components/ui/dialog";

const PrepaidKeyCreatedModal: React.FC = () => {
  const {
    isPrepaidCreatedModalVisible,
    setPrepaidCreatedModalVisible,
    prepaidCreatedDetails,
  } = useModalState();

  const apiKey = prepaidCreatedDetails?.apiKey || "—";
  const credits = prepaidCreatedDetails?.credits || 0;

  // Truncate key for display: first 12 chars...last 8 chars
  const keyDisplay = apiKey.length > 24
    ? `${apiKey.slice(0, 12)}...${apiKey.slice(-8)}`
    : apiKey;

  return (
    <DialogRoot
      lazyMount
      open={isPrepaidCreatedModalVisible}
      onOpenChange={(e) => setPrepaidCreatedModalVisible(e.open)}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Pre-paid key created</DialogTitle>
          <DialogDescription>
            Save this key securely. If you do not already have a CoinCap account, you will not be able to view this key once you leave the CoinCap dashboard.
          </DialogDescription>
          <DialogCloseTrigger />
        </DialogHeader>

        <DialogBody>
          <Flex direction="column" gap={3}>
            {/* API Key row */}
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="sm" color="fg.muted">API Key:</Text>
              <Text fontSize="sm" fontWeight="bold">{keyDisplay}</Text>
            </Flex>

            {/* Credits row */}
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="sm" color="fg.muted">Credits:</Text>
              <Text fontSize="sm" fontWeight="bold">{credits.toLocaleString()}</Text>
            </Flex>
          </Flex>
        </DialogBody>

        <DialogFooter>
          <Button
            variant="solid"
            colorPalette="gray"
            width="full"
            onClick={() => setPrepaidCreatedModalVisible(false)}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default PrepaidKeyCreatedModal;
